export default {
  coinChangeData: {},
  levelChangeData: {},
  currentVideo: {},
  showPoster: false,
  coursePv: 0,
}
